var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('router-link',{attrs:{"to":_vm.$url('publicRegion', _vm.region.id)}},[_vm._v("\n    "+_vm._s(_vm.region.name)+"\n  ")]),_vm._v(" "),(_vm.region.hasAmbassador)?_c('a',{attrs:{"href":_vm.$url('mailto_mail_foodsharing_network', _vm.region.emailAddress)}},[_c('i',{staticClass:"fas fa-envelope"})]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }